/* eslint-disable @typescript-eslint/camelcase */

import ApiService from './api'

export interface CommentsApi {
  getByPostSlug(slug: string, page: number, perPage: number, token: boolean)

  like(slug: string, commentId: number, likes: boolean)

  dislike(slug: string, commentId: number, dislikes: boolean)

  leaveComment(
    slug: string,
    comment: string,
    parentId: number | null,
    username?: string,
    email?: string
  )

  report(id: number, slug: string)
}

export const CommentsApi: CommentsApi = Object.freeze({
  getByPostSlug(slug, page = 1, perPage = 20, token = null) {
    return ApiService.get(
      `/posts/${slug}/comments?page=${page}&perPage=${perPage}`,
      null,
      null,
      token
    )
  },
  like(slug: string, commentId: number) {
    return ApiService.post(`/posts/${slug}/comments/${commentId}/likes`, {
      comment_id: commentId,
      likes: true,
    })
  },
  dislike(slug: string, commentId: number) {
    return ApiService.post(`/posts/${slug}/comments/${commentId}/likes`, {
      comment_id: commentId,
      dislikes: true,
    })
  },
  leaveComment(
    slug: string,
    comment: string,
    parentId: number | null,
    username?: string,
    email?: string
  ) {
    return ApiService.post(`/posts/${slug}/comments`, {
      comment,
      parent_comment_id: parentId ?? 0,
      username,
      email,
    })
  },
  report(id: number, slug: string) {
    return ApiService.post(`/posts/${slug}/comments/${id}/report`, {})
  },
})
